import { render, staticRenderFns } from "./CollegeHeader.vue?vue&type=template&id=7c97c346&scoped=true&"
import script from "./CollegeHeader.vue?vue&type=script&lang=js&"
export * from "./CollegeHeader.vue?vue&type=script&lang=js&"
import style0 from "./CollegeHeader.vue?vue&type=style&index=0&id=7c97c346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c97c346",
  null
  
)

export default component.exports